module.exports = __webpack_public_path__ + "img/explainers.3466d10e.jpg";